import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {GetCongenereEligibility} from 'domain/usecases/private/home/get-congenere-eligibility';

export class RemoteGetCongenereEligibility implements GetCongenereEligibility {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<boolean>,
	) {}

	async get(signal?: AbortSignal): Promise<boolean> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return false;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
